import React from "react";
import BondRetrievalBillingInformation from "./BondRetrievalBillingInformation";
import { GoogleAutoComplete, LabeledCreatableSelect } from "./GuardianshipBondRetrieveHelpers";

const GuardianshipBillingInformation = (props) => (
  <BondRetrievalBillingInformation
    bondType="guardianship"
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    {...props}
  />
);

export default GuardianshipBillingInformation;
